import { render, staticRenderFns } from "./attachment-skeleton.vue?vue&type=template&id=5d4c9e25"
import script from "./attachment-skeleton.vue?vue&type=script&lang=js"
export * from "./attachment-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports